<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="3")
              div {{ $t('ui.full_time') }}
            th(colspan="3")
              div {{ $t('ui.first_half') }}
          tr
            th(style="width: 100px;")
              div.text-center 1
            th(style="width: 100px;")
              div.text-center X
            th(style="width: 100px;")
              div.text-center 2
            th(style="width: 100px;")
              div.text-center 1
            th(style="width: 100px;")
              div.text-center X
            th(style="width: 100px;")
              div.text-center 2
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.f1_blink }") {{ item.f1 }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.fx_blink }") {{ item.fx }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.f2_blink }") {{ item.f2 }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.h1_blink }") {{ item.h1 }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.hx_blink }") {{ item.hx }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.h2_blink }") {{ item.h2 }}
</template>
<script>
import _ from "lodash";

export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>